import * as types from "../actions/actionTypes";

const initialState = {
  savedInfo: {},
  savedData: { date: "", time: "" },
  confirmStatus: false,
  confirmData: false,
  inSelectMode: false,
  modalDataForLongError: {},
  modalStatusForLongError: false
};

const GeneralUtils = (state = initialState, action) => {
  switch (action.type) {
    case types.SAVE_INFO_FOR_CASH_PURPOSE:
      return { ...state, savedInfo: action.payLoad };
    case types.MAINTAIN_DATE_AND_TIME:
      return { ...state, savedData: action.payLoad };
    case types.SET_CONFIRM_DATA_FOR_TABLE:
      return { ...state, confirmData: action.data, confirmStatus: true };
    case types.CLOSE_CONFIRM_FOR_TABLE:
      return { ...state, confirmData: {}, confirmStatus: false };
    case types.TOGGLE_SELECT_MODE_FOR_TABLE:
      return { ...state, inSelectMode: action.status };
    case types.SET_MODAL_DATA_FOR_LONG_ERROR:
      return {
        ...state,
        modalDataForLongError: action.data,
        modalStatusForLongError: true
      };
    case types.CLOSE_MODAL_FOR_LONG_ERROR:
      return {
        ...state,
        modalDataForLongError: {},
        modalStatusForLongError: false
      };
    default:
      return { ...state };
  }
};
export default GeneralUtils;
